import { Link } from "react-router-dom"
import { motion } from "motion/react"

const Page404 = () => {
  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-dark text-light">
      <div className="container">
        <div className="row align-items-center text-center text-md-start">

          {/* Imagen */}
          <div className="col-md-6 mb-4 mb-md-0 d-flex justify-content-center">
            <motion.img
              src={'/img/404.png'}
              alt="404"
              className="img-fluid"
              style={{ maxWidth: "380px" }}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            />
          </div>

          {/* Texto */}
          <div className="col-md-6">
            <motion.h1
              className="display-1 fw-bold"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
            >
              404
            </motion.h1>

            <motion.h2
              className="fw-semibold mb-3"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.35 }}
            >
              Página no encontrada
            </motion.h2>

            <motion.p
              className="text-secondary mb-4"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5 }}
            >
              La página que buscas no existe o fue movida.
              Puedes volver al inicio o regresar a la página anterior.
            </motion.p>

            <motion.div
              className="d-flex gap-3 justify-content-center justify-content-md-start"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.65 }}
            >
              <Link to="/" className="btn btn-primary px-4">
                Inicio
              </Link>

              <button
                className="btn btn-outline-light px-4"
                onClick={() => window.history.back()}
              >
                Regresar
              </button>
            </motion.div>
          </div>

        </div>
      </div>
    </div>
  )
}

export default Page404
